import type { VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandContainer, FeatureIslandHeader } from "@/components/features/_layouts";

import { useInitialized } from "../../model/usecase/existing/use-init";
import { CampaignDetails } from "../_components/root";

type Props = {
	hotelID: string;
	campaignID: string;
	serverModel: VoucherIssuedForCampaignListByHotelIdAndVoucherId_DetailsPageQuery;
};

export const CampaignDetailsPresenter = ({ hotelID, campaignID, serverModel }: Props) => {
	const { data, onUpdateMarkVoucherAsUnUsed, onUpdateMarkVoucherAsUsed } = useInitialized({
		campaignID,
		serverModel,
	});

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader title="キャンペーンの詳細" />
			<CampaignDetails
				hotelID={hotelID}
				data={data}
				onUpdateMarkVoucherAsUnUsed={onUpdateMarkVoucherAsUnUsed}
				onUpdateMarkVoucherAsUsed={onUpdateMarkVoucherAsUsed}
			/>
		</FeatureIslandContainer>
	);
};

CampaignDetailsPresenter.displayName = "CampaignDetailsPresenter";
